export var FORCE_INVOICE_REFRESH = "FORCE_INVOICE_REFRESH";
export var SET_SELECTED_SOLD_TOS = 'SET_SELECTED_SOLD_TOS';
export var REMOVE_SOLD_TO_FROM_SELECTED = 'REMOVE_SOLD_TO_FROM_SELECTED';
export var ADD_SOLD_TO_TO_SELECTED = 'ADD_SOLD_TO_TO_SELECTED';
export var UPDATE_MULTI_SELECT_SOLD_TO = 'UPDATE_MULTI_SELECT_SOLD_TO';
export var SET_IS_LOGGED_IN = 'SET_IS_LOGGED_IN';
export var SET_LOGIN_CHECKED = 'SET_LOGIN_CHECKED';

// Common Actions
export const LOADING_INCREMENT = 'LOADING_INCREMENT';
export const LOADING_DECREMENT = 'LOADING_DECREMENT';
export const CALL_FAILED = 'CALL_FAILED';

// User Actions
export const LOGOUT = 'LOGOUT';
export const SET_LAST_URL = 'SET_LAST_URL';
export const SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT';
export const UN_AUTHORIZED = 'UN_AUTHORIZED';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const UPDATE_PASSWORD_RESPONSE = 'UPDATE_PASSWORD_RESPONSE';

// Invoice List Actions
export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS';

export const GET_PAYER_DETAILS_SUCCESS = 'GET_PAYER_DETAILS_SUCCESS';

export const POST_PAYMENT_REQUEST = 'POST_PAYMENT_REQUEST';
export const POST_PAYMENT_SUCCESS = 'POST_PAYMENT_SUCCESS';

export const GET_INVOICE_CURRENCY_SUCCESS = 'GET_INVOICE_CURRENCY_SUCCESS';

export const GET_PRIMARY_ACCOUNTS_SUCCESS = 'GET_PRIMARY_ACCOUNTS_SUCCESS';

export const GET_API_VERSION_REQUEST = 'GET_API_VERSION_REQUEST';
export const GET_API_VERSION_SUCCESS = 'GET_API_VERSION_SUCCESS';

export const GET_CUSTOM_DATA_SUCCESS = 'GET_CUSTOM_DATA_SUCCESS';
export const SET_CONFIG = 'SET_CONFIG';

export const ADD_INVOICE_TO_SELECTED = 'ADD_INVOICE_TO_SELECTED';
export const REMOVE_INVOICE_FROM_SELECTED = 'REMOVE_INVOICE_FROM_SELECTED';
export const UPDATE_PAY_AMOUNT_FOR_INVOICE = 'UPDATE_PAY_AMOUNT_FOR_INVOICE';
export const UPDATE_REASON = 'UPDATE_REASON';
export const UPDATE_REASON_COMMENT = 'UPDATE_REASON_COMMENT';
export const COPY_SELECTED_INVOICES_TO_COMPLETED = 'MOVE_SELECTED_INVOICES_TO_COMPLETED';
export const CLEAR_SELECTED_INVOICES = 'CLEAR_SELECTED_INVOICES';

export const UPDATE_PAYMENT_CARD_OPTIONS = 'UPDATE_PAYMENT_CARD_OPTIONS';
export const UPDATE_INVOICE_LIST_REQUEST = 'UPDATE_INVOICE_LIST_REQUEST';
export const UPDATE_CURRENCY_CODE = 'UPDATE_CURRENCY_CODE';
export const UPDATE_CURRENCY_OPTIONS = 'UPDATE_CURRENCY_OPTIONS';
export const UPDATE_PAYMENT_STATUS = 'UPDATE_PAYMENT_STATUS';
export const UPDATE_CUSTOMER_OPTIONS = 'UPDATE_CUSTOMER_OPTIONS';
export const UPDATE_SELECTED_CUSTOMER_VALUE = 'UPDATE_SELECTED_CUSTOMER_VALUE';
export const UPDATE_PARTIAL_PAYMENT_ALLOWED_FLAG = 'UPDATE_PARTIAL_PAYMENT_ALLOWED_FLAG';
export const UPDATE_OVER_PAYMENT_ALLOWED_FLAG = 'UPDATE_OVER_PAYMENT_ALLOWED_FLAG';
export const UPDATE_REASON_NOT_REQUIRED_FLAG = 'UPDATE_REASON_NOT_REQUIRED_FLAG';
export const UPDATE_CVV_CONTROL_FLAG = 'UPDATE_CVV_CONTROL_FLAG';
export const ADD_SELECTED_SOLDTO = 'ADD_SELECTED_SOLDTO';
export const REMOVE_UN_SELECTED_SOLDTO = 'REMOVE_UN_SELECTED_SOLDTO';
export const REMOVE_ALL_SELECTED_SOLDTOS = 'REMOVE_ALL_SELECTED_SOLDTOS';
export const UPDATE_CVV = 'UPDATE_CVV';
export const UPDATE_SELECTED_CARD = 'UPDATE_SELECTED_CARD';
export const TOTAL_PAYING_AMOUNT = 'TOTAL_PAYING_AMOUNT';
export const OVER_PAYING_AMOUNT = 'OVER_PAYING_AMOUNT';
export const OVER_PAY_NOTE = 'OVER_PAY_NOTE';
export const INVOICE_SEARCH_FROM_DATE = 'INVOICE_SEARCH_FROM_DATE';
export const INVOICE_SEARCH_TO_DATE = 'INVOICE_SEARCH_TO_DATE';
export const INVOICE_SEARCH_DUE_FROM_DATE = 'INVOICE_SEARCH_DUE_FROM_DATE';
export const INVOICE_SEARCH_DUE_TO_DATE = 'INVOICE_SEARCH_DUE_TO_DATE';
export const UPDATE_INVOICE_SEARCH_QUERY = 'UPDATE_INVOICE_SEARCH_QUERY';
export const UPDATE_INVOICE_SEARCH_MODE = 'UPDATE_INVOICE_SEARCH_MODE';
export const UPDATE_IMPERSONATE_USER_ID = 'UPDATE_IMPERSONATE_USER_ID';
export const SET_ACCOUNT_TYPE = 'SET_ACCOUNT_TYPE';
export const UPDATE_ACCOUNT_TYPES = 'UPDATE_ACCOUNT_TYPES';
export const UPDATE_PRIMARY_ACCOUNT_TYPES = 'UPDATE_PRIMARY_ACCOUNT_TYPES';

export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS';

